import React, { useState, useEffect } from "react" ;

import MyContributorsAppSidebar from "./Sidebar/MyContributorsAppSidebar";
import MyContributorsAppBody from "./Body/MyContributorsAppBody";

const WieldyApplicationModuleMyContributors = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    <MyContributorsAppSidebar title={'My Contributors'} iconName={'icon-family'} height={height} width={width}/>
                    <MyContributorsAppBody height={height}/>
                    { /* <UsersAppDrawer /> */ }

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleMyContributors;